import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import './KwicTable.css';

class Tree extends React.PureComponent {

  state = {
     
  }

  render() {
    // const svg=this.props.data.replace(/viewBox=".*?"/,"");
    const { svg } = this.props;
        return (
            <div className="svgContainer dialogContainer">
                <center><div dangerouslySetInnerHTML={{__html:svg}}></div></center>
            </div>
  
        );

  }
}

Tree.propTypes = {
  // see prepCoocData for an example
  svg: PropTypes.string,
};

export default withTranslation()(Tree);
